@if (profile()?.id && sessionBackupService.previousSessionContext()) {
  <div class="session-content-status-banner">
    <lib-icon icon="warning-circle"></lib-icon>
    {{ 'COMMON.you_are_logged_in_as' | translate : { name: userName() } }}
    <span class="switch-back" role="button" (click)="switchBack()">
      {{ 'COMMON.switch_back' | translate }}
    </span>
    <button mat-icon-button class="button button--icon button--icon-extra-small close-button" (click)="clearOriginalSession()">
      <lib-icon icon="x" [size]="16"></lib-icon>
    </button>
  </div>
}
